import { Nav } from "react-bootstrap";
import { Link } from "react-router-dom";
import Icon from "../Icon";
import { FormattedMessage } from 'react-intl';

const MobilMenu = ({mode, toogleMode, isArchive}) => {

    const tartalom = () => {
        const button = document.querySelector("#charts");
        if (button) {
            button.click();
        }
    }
    return (<Nav fill
        className="mobil-menu  d-sm-none"
        activeKey="/"
      >
        <Nav.Item>
          <Link to="/"><Icon icon="home" className={"white"} /><br/><FormattedMessage id="home_page" defaultMessage="Nyítólap" /></Link>
        </Nav.Item>
        {!isArchive&&<Nav.Item>
          <div onClick={() => tartalom()}><Icon icon="chart" className={"white"} /><br/><FormattedMessage id="table_of_contents" defaultMessage="Tartalom" /></div>
        </Nav.Item>}
        <Nav.Item>
          <div onClick={toogleMode}>{mode&&mode==="dark"&&<Icon icon={"sun"} className={"white"} ></Icon>}
          {mode&&mode!=="dark"&&<Icon icon={"moon"}  className={"white"} ></Icon>}<br/>{mode&&mode==="dark"?"Világos":"Sötét"}</div>
        </Nav.Item>
        <Nav.Item>
          <div onClick={() => window.feedback.show()}><Icon icon={"feedback"} className={"white"} /><br/><FormattedMessage id="feedback" defaultMessage="Visszajelzés" /></div>
        </Nav.Item>
      </Nav>)
}

export default MobilMenu;
